import { postGrowthEngineAnalytics } from 'src/utils/growthEngineApi'

/**
 * GE-013 supplier-led invite funnel helpers.
 *
 * Persisted (Growth Engine, needs venueId — written mainly from API after invite):
 * - supplier_invite_submitted
 * - supplier_invite_relationship_created / reused
 * - supplier_invite_email_sent / failed
 * - supplier_invite_resent
 *
 * Session-only (no venue yet — not in Growth Engine):
 * - invite_panel_viewed
 * - invite_form_opened
 * - invite_submit_attempted
 *
 * MISSING / not measured in this ticket (need customer-app or order signals):
 * - Customer accessed the invited venue
 * - First valid order
 * - Repeat ordering
 * (Do not invent these from email open / general login.)
 */

export const SUPPLIER_INVITE_FEATURE_ID = 'supplier_led_invite'

export const SUPPLIER_INVITE_FUNNEL = Object.freeze({
  PANEL_VIEWED: 'invite_panel_viewed',
  FORM_OPENED: 'invite_form_opened',
  SUBMIT_ATTEMPTED: 'invite_submit_attempted',
  RELATIONSHIP_CREATED: 'supplier_invite_relationship_created',
  RELATIONSHIP_REUSED: 'supplier_invite_relationship_reused',
  EMAIL_SENT: 'supplier_invite_email_sent',
  EMAIL_FAILED: 'supplier_invite_email_failed',
  RESENT: 'supplier_invite_resent',
  SUBMITTED: 'supplier_invite_submitted',
})

const SESSION_KEY = 'oms-supplier-invite-funnel-log'

const appendSessionFunnel = entry => {
  if (typeof sessionStorage === 'undefined') return
  try {
    const existing = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '[]')
    const next = Array.isArray(existing) ? existing : []
    next.push({
      ...entry,
      at: entry.at || new Date().toISOString(),
    })
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(next.slice(-100)))
  } catch (_) {
    // never block UX
  }
}

/**
 * Fire-and-forget. Never throws. Never blocks invite UX.
 */
export const trackSupplierInviteFunnel = ({
  eventName,
  venueId,
  supplierId,
  metadata = {},
} = {}) => {
  try {
    if (!eventName) return

    const payload = {
      eventName,
      supplierId: supplierId || null,
      venueId: venueId || null,
      isResend: Boolean(metadata.isResend),
      ...metadata,
    }

    appendSessionFunnel(payload)

    // Growth Engine requires a venue — skip silently when absent
    if (!venueId) return

    postGrowthEngineAnalytics(venueId, {
      eventName,
      featureId: SUPPLIER_INVITE_FEATURE_ID,
      platform: 'dashboard',
      metadata: {
        source: 'supplier_portal',
        growthInvestigation: 'GE-013',
        supplierId: supplierId || undefined,
        ...metadata,
      },
    }).catch(() => {})
  } catch (_) {
    // never block UX
  }
}

export const readSupplierInviteFunnelSessionLog = () => {
  if (typeof sessionStorage === 'undefined') return []
  try {
    const parsed = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch (_) {
    return []
  }
}
